import type { ProfileSummary } from './api';

export type SessionState =
  | 'INITIALIZING'
  | 'GUEST'
  | 'SIGNED_IN_UNVERIFIED'
  | 'KEYRA_VERIFIED'
  | 'EXPIRED';

export function deriveSessionState(input: {
  loading: boolean;
  authenticated: boolean;
  profile: ProfileSummary | null;
  keyraVerified?: boolean;
  expired?: boolean;
}): SessionState {
  if (input.loading) return 'INITIALIZING';
  if (input.expired) return 'EXPIRED';
  if (!input.authenticated) return 'GUEST';
  if (input.keyraVerified === false) return 'SIGNED_IN_UNVERIFIED';
  return 'KEYRA_VERIFIED';
}

export function canAccessProtectedAction(state: SessionState): boolean {
  return state === 'KEYRA_VERIFIED';
}
